import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotRecommend from "./components/HotRecommend";
import CategoryShowcase from "./components/CategoryShowcase";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "韩漫网",
  url: "http://hongtongren.com/",
  description: "韩漫网致力于为您提供高清韩国漫画的免费在线阅读，拥有丰富韩漫大全和易用网址，覆盖多种类型，让您尽情享受阅读的快乐。",
  sameAs: ["http://hongtongren.com/"],
};

export default function HomePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar isTransparent={true} />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryShowcase />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
